export default function Comment() {
  return <>Comment</>;
}
